//import Vue from 'vue'
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import { AuthModule } from "./modules/auth/";
import { coreModule } from "./modules/core/";
import { IRootState } from "./types";

//Vue.use(Vuex)

const vuexLocal = new VuexPersistence<IRootState>({
  storage: window.localStorage,
});

export default new Vuex.Store<IRootState>({
  state: {
    loading: false,
  },
  modules: {
    auth: AuthModule,
    core: coreModule,
  },
  plugins: [vuexLocal.plugin],
});
